import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=f6336be4&scoped=true&"
import script from "./kaoshi.vue?vue&type=script&lang=js&"
export * from "./kaoshi.vue?vue&type=script&lang=js&"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=f6336be4&lang=scss&scoped=true&"
import style1 from "./kaoshi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6336be4",
  null
  
)

export default component.exports